import CardCourse from './card-course'

export default CardCourse
